import React from "react";
import { Link } from "react-router-dom";

const Breadcrumb = ({ title, highlight, paths }) => {
    return (
        <section className="py-3 pt-4 section-background">
            <div className="container">
                <div className="d-flex justify-content-between align-items-center align-self-center">
                    <h3 className="text-dark fw-600 d-none d-md-block pb-0">
                        {title} {highlight && <span className="text-orange">{highlight}</span>}
                    </h3>
                    <ol className="d-flex justify-content-center align-items-center m-0 p-0" style={{ listStyle: "none" }}>
                        {paths.map((path, index) => (
                            <React.Fragment key={index}>
                                <li>
                                    {path.link ? (
                                        <Link to={path.link} className="text-orange text-decoration-none">
                                            {path.name}
                                        </Link>
                                    ) : (
                                        <span className="text-dark">{path.name}</span>
                                    )}
                                </li>
                                {index < paths.length - 1 && <span className="mx-2">/</span>}
                            </React.Fragment>
                        ))}
                    </ol>
                </div>
            </div>
        </section>
    );
};

export default Breadcrumb;
